import { useEffect, useState } from "react";

const REFRESH_MS = 1000 * 60 * 5; // 5 minutes

export default function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), REFRESH_MS);
    return () => clearInterval(id);
  }, []);
  return now;
}
